.form {
  display: block;
  container-type: inline-size;
}

.inputWrapper > div {
  margin-bottom: 0 !important;
}

.inputWrapper :is(input, textarea) {
  margin-bottom: 0 !important;
}

.receipt {
  margin-top: 1rem;
}
